import {queryOptions} from '@tanstack/react-query';
import {getPrivateAxios} from '../../libs';
import {BillingDiscount} from '../teams';

type ProcessWelcomeDiscountPayload = {
  type: 'discount';
  payload: 'welcome';
};

/**
 *
 * @returns
 */
export const fetchProcessWelcomeDiscount = async (payload: ProcessWelcomeDiscountPayload) => {
  const {data} = await getPrivateAxios().post<BillingDiscount | null>(
    '/user-events/process',
    payload,
  );
  return data;
};

export const processWelcomeDiscountQueryOptions = (payload: ProcessWelcomeDiscountPayload) =>
  queryOptions({
    queryKey: ['process-welcome-discount', payload],
    queryFn: () => fetchProcessWelcomeDiscount(payload),
  });
